import React, { useContext, useEffect } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import authContext from '../context/authContext/authContext';
import dataContext from '../context/dataContext/dataContext';

const Navbar = ({ sidebarOpen, closeSidebar }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useContext(authContext);
  const { getAllowedPages } = useContext(dataContext)

  const getClassName = (path) => {
    const baseClass = 'dropdown-toggle no-arrow';
    if (pathname === path) {
      return `${baseClass} active`;
    }

    return baseClass;
  };

  const pages = getAllowedPages(pathname);

  useEffect(() => {
    if (user) {
      // getPartners();
    } else {
      navigate('/login');
      return;
    }
  }, []);

  const internalClose = () => {
    const sidebar = document.querySelector('.left-side-bar');
    const overlay = document.querySelector('.mobile-menu-overlay');
    const menuIcon = document.querySelector('.menu-icon');
    if (sidebar) sidebar.classList.remove('open');
    if (overlay) overlay.classList.remove('show');
    if (menuIcon) menuIcon.classList.remove('open');
  };

  // prefer prop closeSidebar when provided
  const handleClose = closeSidebar || internalClose;

  useEffect(() => {
    handleClose();
  }, [pathname]);

  if (!pages.includes(pathname)) {
    return null;
  }

  return (
    <>
      <div className={`mobile-menu-overlay${sidebarOpen ? ' show' : ''}`} onClick={handleClose} />
      <div className={`left-side-bar${sidebarOpen ? ' open' : ''}`}>
        <div className="brand-logo">
          <Link to="/dashboard" onClick={closeSidebar}>
            <img src="assets/images/gleamDesk.png" alt="" style={{ height: '90%' }} className="light-logo" />
            <img src="assets/images/gleamDesk.png" alt="" style={{ height: '90%' }} className="dark-logo" />
            <h3 style={{ color: '#0097b2' }}>GleamDesk</h3>
          </Link>
          <div className="close-sidebar" data-toggle="left-sidebar-close" onClick={handleClose} role="button" aria-label="Close sidebar" tabIndex={0}>
            <i className="ion-close-round" />
          </div>
        </div>
      <div className="menu-block customscroll">
        <div className="sidebar-menu">
          <ul id="accordion-menu">
            <li>
              <Link className={getClassName('/dashboard')} to="/dashboard">
                <span className="micon dw dw-house-1" />
                <span className="mtext">Dashboard</span>
              </Link>
            </li>
            <li>
              <Link className={getClassName('/users')} to="/users">
                <span className="micon dw dw-user-11" />
                <span className="mtext">Users</span>
              </Link>
            </li>
            <li>
              <Link className={getClassName('/demat-users')} to="/demat-users">
                <span className="micon dw dw-user-13" />
                <span className="mtext">Demat Requests</span>
              </Link>
            </li>
            <li>
              <Link className={getClassName('/payouts')} to="/payouts">
                <span className="micon dw dw-credit-card" />
                <span className="mtext">Payouts</span>
              </Link>
            </li>
            <li>
              <Link className={getClassName('/appointments')} to="/appointments">
                <span className="micon dw dw-calendar1" />
                <span className="mtext">Appointments</span>
              </Link>
            </li>
            {/* <li className="dropdown">
              <Link to="/partners" className="dropdown-toggle">
                <span className="micon fa fa-handshake-o" />
                <span className="mtext">Partners</span>
              </Link>
              <ul className="submenu">
                {(partners || []).map((partner) => {
                  return (
                    <li>
                      <Link to={`/partner/${partner?._id}`}>{partner?.name}</Link>
                    </li>
                  )
                })}
              </ul>
            </li> */}
            <li>
              <Link to="/partners" className={getClassName('/partners')}>
                <span className="micon 	fa fa-handshake-o" />
                <span className="mtext">Partners</span>
              </Link>
            </li>
            <li>
              <Link to="/achievements" className={getClassName('/achievements')}>
                <span className="micon fa fa-trophy" />
                <span className="mtext">Achievements</span>
              </Link>
            </li>
               <li>
              <Link to="/ads" className={getClassName('/ads')}>
                <span className="micon fa fa-bullhorn" />
                <span className="mtext">Ads</span>
              </Link>
            </li>
            <li>
              <Link to="/products" className={getClassName('/products')}>
                <span className="micon 	fa fa-th-large" />
                <span className="mtext">Products</span>
              </Link>
            </li>
            <li>
              <Link to="/selected-products" className={getClassName('/selected-products')}>
                <span className="micon 	fa fa-th" />
                <span className="mtext">Selected Products</span>
              </Link>
            </li>
            <li>
              <Link className={getClassName('/subscribers')} to="/subscribers">
                <span className="micon fa fa-envelope-o" />
                <span className="mtext">Subscribers</span>
              </Link>
            </li>
            <li>
              <Link to="/propdesks" className={getClassName('/propdesks')}>
                <span className="micon fa fa-line-chart" />
                <span className="mtext">Propdesks</span>
              </Link>
            </li>
            <li>
              <Link to="/stock" className={getClassName('/stock')}>
                <span className="micon fa fa-pie-chart" />
                <span className="mtext">Stock of the month</span>
              </Link>
            </li>
            {/* <li>
              <a href="sitemap.html" className="dropdown-toggle no-arrow">
                <span className="micon dw dw-diagram" />
                <span className="mtext">Sitemap</span>
              </a>
            </li> */}

            <li>
              <a
                href={process.env.REACT_APP_GLEAMDESK_URL}
                target="_blank"
                className="dropdown-toggle no-arrow"
              >
                <span className="micon dw dw-paper-plane1" />
                <span className="mtext">
                  GleamDesk
                  <img src="/assets/images/gleamDesk.png" alt="" width={25} className='ml-2' />
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    </>
  )
}

export default Navbar